import React, { useEffect, useContext, useState } from 'react';

import { LoginContext } from '../../hooks/context/LoginContext';

import Menusup from '../../componentes/menus/menusup/Menusup';
import Sidebar from '../../componentes/menus/sidebar/Sidebar';
import Formulario from '../../componentes/formulario/Formulario';
import FormRow from '../../componentes/formulario/FormRow';
import FormInput from '../../componentes/formulario/FormInput';
import Footer from '../../componentes/footer/Footer';
import Section from '../../componentes/ui/Section';
import MiDataTable from '../../componentes/ui/MiDataTable';
import { Alert } from '../../componentes/ui/Alert';
import MiSelect from '../../componentes/formulario/MiSelect';
import PermissionRefused from '../../componentes/ui/PermissionRefused';
import LoadingPage from '../../componentes/ui/LoadingPage';

import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import Spinner from 'react-bootstrap/Spinner';

import useLogicForm from '../../hooks/useLogicForm';

import Cookies from 'universal-cookie';

import { Fragment } from 'react';

import { getTitle, getDecodedCookie } from '../../helpers/helperApp';

function TipAge(props){

    const cookies = new Cookies();

    // ***** Context *****
    const { validateSesion, socket, confApp, saveConfApp, getConfApp } = useContext(LoginContext);    

    // ***** State para la configuración de la pantalla *****
    const [ confPantalla, saveConfPantalla ] = useState(confApp)
    const [ loadedConf, saveLoadedConf ] = useState(false);
    const [ tieneNivel, saveTieneNivel ] = useState(true);
    const [ estadoFormPrin, saveEstadoFormPrin ] = useState("");
    const [ estadoFormHijo, saveEstadoFormHijo ] = useState("");

    // ***** Custom Hook - Lógica de los formularios *****
    const { registrosPrin, saveRegistrosPrin, formularioPrin, saveFormularioPrin, saveFormularioHijo , handleInputForm, handleLastReg, handleEditRegPrin, loadingTable, saveLoadingTable, loadReg, regIniciales, handleDeleteItemPrin, handleSubmitPrin, resetFormPrin, handleSelectFormPrin } = useLogicForm();

    useEffect( () => {        
        
        // ***** Validamos que el usuario esté logueado sino lo enviamos al login*****
        validateSesion(props)
            .then( (respuesta) => {
                if( confPantalla === undefined ){
                    return getConfApp();
                }else{                             
                    document.title = getTitle(confPantalla.config.trad, confPantalla.tipage.title);                    
                    if( respuesta == 1 ){
                        saveTieneNivel(true);
                        saveEstadoFormPrin(confPantalla.tipage.padre.estadoform);
                        saveEstadoFormHijo(confPantalla.tipage.hijo.estadoform);                             
                        // ***** Carga inicial de registros *****
                        if( registrosPrin ){
                            if( registrosPrin.length === 0 ){
                                saveLoadingTable(true);
                                regIniciales(saveRegistrosPrin, confPantalla.tipage.padre.urls);
                                saveFormularioPrin(confPantalla.tipage.padre.modelform);
                                saveFormularioHijo(confPantalla.tipage.hijo.modelform);     
                            }
                        }  
                        // Seleccionar el id que nos llega como parámetro por la url
                        if( props.location.state ){
                            if( "idPrin" in props.location.state || "idHijo" in props.location.state ){
                                handleLastReg(props.location.state.idPrin, props.location.state.idHijo, confPantalla.tipage.padre.urls, confPantalla.tipage.hijo.urls, confPantalla.tipage.padre.tabla, props.location.state.estadoFormPrin, saveEstadoFormPrin, saveEstadoFormHijo);    
                            }                        
                        }                      
                    }
                    else if( respuesta == 0 ){
                        saveTieneNivel(false);
                    }                    
                    saveLoadedConf(true);        
                }
            })
            .then( (respuesta) => {
                if( respuesta !== undefined  ){
                    saveConfPantalla(respuesta.msg);
                    saveConfApp(respuesta.msg);             
                }
            })          

        // Liberamos todos los registros al salir de la pantalla
        return () =>{
            if( socket != null ){
                socket.emit("salirPantalla", { "idusu": getDecodedCookie('id'), "tabla": "undefined" })
            }
                document.querySelector("body").classList.remove("sidebar-open");
        } 

    },[confPantalla])
 

    return(
        <div className="App wrapper">
            <div>
                {   loadReg ?
                    <div className="alertFullWhite">
                        <Spinner animation="border" />
                    </div> 
                    :
                    null
                }
                {
                    !loadReg ?
                        <Alert fondo={true} />
                    :
                        <Alert />
                }                                
            </div>    
        {
            confPantalla !== undefined
            ?
                <Fragment>
                    <Menusup 
                        props = { props }
                    />
                    <Sidebar 
                        props = { props }
                    />
                </Fragment>
            :
            null
        } 
        <div className="content-wrapper">
            <div className="content-header">
            </div>
            <section className="content">
                {
                    !tieneNivel 
                    ?
                        <PermissionRefused
                            traduction={confPantalla.config.trad.components.permissionrefused} 
                        />
                    :
                    <Fragment>
                    {
                        loadedConf === true && confPantalla !== undefined
                        ?
                        <Section titulo={ confPantalla.tipage.section.titulo } icono={ confPantalla.tipage.section.icono } col={ confPantalla.tipage.section.col } idPrin={ formularioPrin.id } wiki={ confPantalla.tipage.section.wiki } >
                            <Formulario 
                                        estadoForm= { estadoFormPrin }
                                        loading=    { loadReg ? true : false }
                                        btnNew={ confPantalla.tipage.padre.btnform.new }
                                        btnSave={ confPantalla.tipage.padre.btnform.save }
                                        btnSaveAndNew={ confPantalla.tipage.padre.btnform.saveandnew }
                                        btnDelete={ confPantalla.tipage.padre.btnform.delete }
                                        btnClone={ confPantalla.tipage.padre.btnform.clone }
                                        handleSubmit = { e => handleSubmitPrin(e, confPantalla.tipage.padre.urls, confPantalla.tipage.padre.modelform, confPantalla.tipage.padre.tabla, confPantalla.tipage.hijo.modelform, confPantalla.tipage.title) } 
                                        formulario = { formularioPrin } 
                                        resetForm = { e => resetFormPrin(confPantalla.tipage.padre.modelform, true, confPantalla.tipage.padre.tabla) } 
                                        handleDeleteItem = { e => handleDeleteItemPrin(undefined, confPantalla.tipage.padre.urls, confPantalla.tipage.padre.modelform, confPantalla.tipage.padre.tabla, confPantalla.tipage.title) } 
                            >         
                            <h4>{ formularioPrin.ruta }</h4>   
                                <FormRow clases="" >
                                    <MiSelect  
                                        estadoForm=  { estadoFormPrin }
                                        val=         { formularioPrin.pad  }   
                                        loading=     { loadReg ? true : false }
                                        id=          { confPantalla.tipage.padre.controles.pad.id }    
                                        name=        { confPantalla.tipage.padre.controles.pad.name }   
                                        label=       { confPantalla.tipage.padre.controles.pad.label }    
                                        placeholder= { confPantalla.tipage.padre.controles.pad.placeholder }
                                        col=         { confPantalla.tipage.padre.controles.pad.col } 
                                        isClearable= { confPantalla.tipage.padre.controles.pad.isclearable }
                                        isSearchable={ confPantalla.tipage.padre.controles.pad.issearchable }
                                        dataType=    { confPantalla.tipage.padre.controles.pad.datatype }
                                        data=        { confPantalla.tipage.padre.controles.pad.data }
                                        required=    { confPantalla.tipage.padre.controles.pad.required } 
                                        disabled=    { confPantalla.tipage.padre.controles.pad.disabled }
                                        readOnly =   { confPantalla.tipage.padre.controles.pad.readonly }
                                        disablethisid={confPantalla.tipage.padre.controles.pad.disablethisid}
                                        formulario = { formularioPrin } 
                                        change=      { handleSelectFormPrin }                                                    
                                    />                                    
                                    <FormInput                                                        
                                        estadoForm= { estadoFormPrin }
                                        value=      { formularioPrin.nom }
                                        loading=    { loadReg ? true : false }
                                        id=         { confPantalla.tipage.padre.controles.nom.id }   
                                        type=       { confPantalla.tipage.padre.controles.nom.type }  
                                        name=       { confPantalla.tipage.padre.controles.nom.name }   
                                        label=      { confPantalla.tipage.padre.controles.nom.label }                                                       
                                        placeholder={ confPantalla.tipage.padre.controles.nom.placeholder }    
                                        col=        { confPantalla.tipage.padre.controles.nom.col } 
                                        required=   { confPantalla.tipage.padre.controles.nom.required }
                                        readonly=   { confPantalla.tipage.padre.controles.nom.readonly }                                                
                                        disabled=   { confPantalla.tipage.padre.controles.nom.disabled }
                                        change=     { e => handleInputForm(e, formularioPrin, saveFormularioPrin) }
                                        onBlur=     {null} 
                                    /> 
                                    <FormInput                                                        
                                        estadoForm= { estadoFormPrin }
                                        value=      { formularioPrin.nom_en }
                                        loading=    { loadReg ? true : false }
                                        id=         { confPantalla.tipage.padre.controles.nom_en.id }   
                                        type=       { confPantalla.tipage.padre.controles.nom_en.type }  
                                        name=       { confPantalla.tipage.padre.controles.nom_en.name }   
                                        label=      { confPantalla.tipage.padre.controles.nom_en.label }                                                       
                                        placeholder={ confPantalla.tipage.padre.controles.nom_en.placeholder }    
                                        col=        { confPantalla.tipage.padre.controles.nom_en.col } 
                                        required=   { confPantalla.tipage.padre.controles.nom_en.required }
                                        readonly=   { confPantalla.tipage.padre.controles.nom_en.readonly }                                                
                                        disabled=   { confPantalla.tipage.padre.controles.nom_en.disabled }
                                        change=     { e => handleInputForm(e, formularioPrin, saveFormularioPrin) }
                                        onBlur=     {null} 
                                    /> 
                                </FormRow>                            
                            </Formulario>
                            <MiDataTable
                                formulario={formularioPrin} 
                                estadoForm= { estadoFormPrin }
                                id={"tipage"}
                                columnas={confPantalla.tipage.padre.datatable.columns}
                                data={registrosPrin}
                                buttons={confPantalla.tipage.padre.datatable.buttons}
                                ordering={confPantalla.tipage.padre.datatable.ordering}
                                order={confPantalla.tipage.padre.datatable.order}
                                searching={confPantalla.tipage.padre.datatable.searching}
                                paging={confPantalla.tipage.padre.datatable.paging}
                                select={confPantalla.tipage.padre.datatable.select}
                                pagelength={confPantalla.tipage.padre.datatable.pagelength}
                                handleEditReg= { e => handleEditRegPrin(e, confPantalla.tipage.padre.urls, confPantalla.tipage.hijo.urls, confPantalla.tipage.padreshijos, confPantalla.tipage.hijo.modelform, confPantalla.tipage.padre.tabla) }
                                handleDeleteItem={ e => handleDeleteItemPrin(e, confPantalla.tipage.padre.urls, confPantalla.tipage.padre.modelform, confPantalla.tipage.padre.tabla, confPantalla.tipage.title) }
                                saveLoadingTable={ saveLoadingTable }
                                loadingTable={loadingTable}
                                columnactions={confPantalla.tipage.padre.datatable.columnactions.title}
                                traduction={confPantalla.config.trad.components.datatable}
                            />                                                                                                             
                            </Section>
                        :
                            <LoadingPage />
                        }
                    </Fragment>
                }
                
            </section>
        </div>
        <Footer />        
        </div>

    );

}
export default TipAge